// src/app/features/otp/otpService.js
import axios from "axios";
import { base_url, getConfig } from "../../../utils/axiosConfig";

/**
 * ✅ PHONE-ONLY OTP SERVICE
 * - send: requires { identity, type:"phone", purpose }
 * - verify: requires { identity, code, type:"phone", purpose }
 */

// Send OTP
const sendOtp = async ({ identity, type = "phone", purpose = "login" }) => {
  const response = await axios.post(
    `${base_url}otp/send`,
    { identity, type, purpose },
    getConfig()
  );

  return response.data;
};

// Verify OTP
const verifyOtp = async ({
  identity,
  code,
  type = "phone",
  purpose = "login",
}) => {
  const response = await axios.post(
    `${base_url}otp/verify`,
    { identity, code, type, purpose },
    getConfig()
  );

  return response.data;
};

const otpService = {
  sendOtp,
  verifyOtp,
};

export default otpService;
